import { render } from 'preact';

import './helpers/dropdown-handler';

import FreeSignup from './app/free-signup-v1';

render(<FreeSignup />, document.getElementById('wrapper'));
